jQuery(function($){
	console.log('Welcome to Haberfeld');

	$('.entry-file').parents().filter(function() {
	    console.log($(this));
	    console.log($(this).css('overflow'));
	    return $(this).css('overflow') === 'hidden';
	});
});